import { Component, OnInit, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { CustomSnackBarData } from '@models/index.model';

@Component({
    selector: 'app-custom-snackbar',
    templateUrl: './custom-snackbar.component.html',
    styleUrls: ['./custom-snackbar.component.scss'],
    standalone: false
})
export class CustomSnackbarComponent implements OnInit {
  icon: string;
  title: string;
  message: string;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: CustomSnackBarData) {
    this.icon = data.icon;
    this.title = data.title;
    this.message = data.message;
  }

  ngOnInit(): void {
  }

}
